import { ITableColumnAbook } from '@models/Forms/IForms';

export const hasChildWithClass = (baseElement: Element, className: string[]) => {
    let element: Element = baseElement;
    if (element.classList && className.some((x) => element.classList.contains(x))) {
        return true;
    }

    for (let child of element.children) {
        if (hasChildWithClass(child, className)) {
            return true;
        }
    }

    return false;
};

/**
 * Просмотр abook-ячейки таблицы: пары (ФИО, ключ адресной книги) для hover-карточек.
 * Ключи лежат в значении самой колонки строки (p.value = p.data[column.key] = "k1|k2|…",
 * порядок выбора), а ФИО — в отдельном display-поле строки (p.data[displayFieldName] — ПЛОСКАЯ
 * строка). Сопоставление по индексу надёжно ТОЛЬКО когда весь displayFormat — это ровно один
 * плейсхолдер {display-поле} обычного (не табличного) абука и число имён = числу ключей.
 * Иначе (eval / table-source / мультиполя+литералы / рассинхрон) → null → рендер как раньше, без hover.
 */
export const buildAbookCellPairs = (column: ITableColumnAbook, p: any): { name: string; key: string }[] | null => {
    const displayFormat = column?.displayFormat;
    if (!displayFormat || column?.evalDisplayFormat || column?.source?.table || !column?.key) return null;

    const placeholders = Array.from(displayFormat.matchAll(/\{.*?\}/g));
    if (placeholders.length !== 1 || displayFormat.trim() !== placeholders[0][0]) return null;

    const keys = String(p?.value ?? p?.data?.[column.key] ?? '')
        .split('|')
        .map((k) => k.trim())
        .filter(Boolean);
    if (keys.length === 0) return null;

    const displayFieldName = placeholders[0][0].slice(1, -1); // убираем { }
    const names = String(p?.data?.[displayFieldName] ?? '').split('|');
    if (names.length !== keys.length) return null;

    return names.map((name, i) => ({ name, key: keys[i] }));
};
